import React from 'react';
import { Card } from 'react-bootstrap';
import { strings } from '../../../../resources/strings';
import { MultifocalInfo } from '../../../../models/MultifocalInfo';
import { Field, FieldType } from '../../../../common-components/Field/Field';
import { FormRecipeValues } from '../FormRecipe';
import { Container, FormMultifocalInfo } from './styles';
import { Frame } from '../../../../models/Frame';

interface TabMultifocalProps {
    values?: FormRecipeValues;
    change: (values: FormRecipeValues) => void;
    frames?: Frame[];
}

const TabMultifocal: React.FC<TabMultifocalProps> = ({
    values,
    change,
    frames
}) => {

    React.useEffect(() => {
        setTimeout(() => confirmMultifocalInfo(), 500);
    }, []);

    return (
        <Container>
            <Card border="secondary" style={{marginTop:'5px'}}>
                <Card.Header>{strings.Frame}</Card.Header>
                <Card.Body>
                    <FormMultifocalInfo>
                        <Field 
                            type={FieldType.Text}
                            label={strings.Bridge}
                            value={values?.multifocalInfo?.actualBridge}
                            change={(value) => changeMultifocalBridge(value)}
                            marginRight='10px'
                            marginTop='0px'
                        /> 
                        <Field 
                            type={FieldType.Text}
                            label={strings.Rim}
                            value={values?.multifocalInfo?.actualEyeWidth}
                            change={(value) => changeMultifocalEyeWidth(value)}
                            marginRight='10px'
                            marginTop='0px'
                        />
                        <Field 
                            type={FieldType.Text}
                            label={strings.Vertical}
                            value={values?.multifocalInfo?.actualEyeHeight}
                            change={(value) => changeMultifocalEyeHeight(value)}
                            marginRight='10px'
                            marginTop='0px'
                        />
                        <Field 
                            type={FieldType.Text}
                            label={strings.LargestDiagonal}
                            value={values?.multifocalInfo?.actualLargestDiagonal}
                            change={(value) => changeMultifocalLargestDiagonal(value)}
                            marginTop='0px'
                        />
                    </FormMultifocalInfo>
                </Card.Body>
            </Card>
        </Container>
    );

    function changeMultifocalBridge(value?: number|null) {
        if (!values) values = new FormRecipeValues();
        if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
        values.multifocalInfo.actualBridge = value;
        change({...values});
    }

    function changeMultifocalEyeWidth(value?: number|null) {
        if (!values) values = new FormRecipeValues();
        if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
        values.multifocalInfo.actualEyeWidth = value;
        change({...values});
    }

    function changeMultifocalEyeHeight(value?: number|null) {
        if (!values) values = new FormRecipeValues();
        if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
        values.multifocalInfo.actualEyeHeight = value;
        change({...values});
    }

    function changeMultifocalLargestDiagonal(value?: number|null) {
        if (!values) values = new FormRecipeValues();
        if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
        values.multifocalInfo.actualLargestDiagonal = value;
        change({...values});
    }

    function confirmMultifocalInfo() {
        if (!values) values = new FormRecipeValues();

        if (!values.multifocalInfoIsConfirmed && frames && frames.length === 1) {
            if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
            values.multifocalInfo.actualBridge = frames[0].bridge;
            values.multifocalInfo.actualEyeWidth = frames[0].eyeWidth;
            values.multifocalInfo.actualEyeHeight = frames[0].eyeHeight;
            values.multifocalInfo.actualLargestDiagonal = frames[0].largestDiagonal;
        }

        values.multifocalInfoIsConfirmed = true;
        change({...values});
    }

};

export {TabMultifocal};